import { bannerHealth, newsContent } from "./../inc/Datamenu_inc";
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import { useRef, useEffect, useState } from "react";
import Loading from "../component/Loading";
// import { useNavigate } from "react-router-dom";
import Card from "../component/Card";
import { dataFloor } from "./../inc/Datamenu_inc";
import { motion } from "framer-motion";

export default function Home() {
  const containerRef = useRef(null);
  const viewerInstance = useRef(null);
  // const navigate = useNavigate();
  // สถานะเพื่อตรวจสอบว่าขณะนี้เป็นหน้าจอมือถือหรือไม่
  const [isMobile, setIsMobile] = useState(false);

  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6; // จํานวนรายการต่อหน้า
  const maxPagesToShow = 6; // จำนวนหน้าที่แสดงใน pagination

  // คำนวณ index ของรายการที่แสดงในหน้าปัจจุบัน
  const totalPages = Math.ceil(posts.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = posts.slice(indexOfFirstItem, indexOfLastItem);

  // ฟังก์ชันเปลี่ยนหน้า
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const PAGE_ID = process.env.REACT_APP_PAGE_ID;
  const PAGE_ACCESS_TOKEN = process.env.REACT_APP_PAGE_ACCESS_TOKEN;
  const perPage = 20; // จำนวนโพสต์ต่อหน้า
  const API_URL = `https://graph.facebook.com/v25.0/${PAGE_ID}/feed?fields=created_time,message,full_picture,updated_time,actions,status_type,attachments{media{source},type}&limit=${perPage}&access_token=${PAGE_ACCESS_TOKEN}`;


  useEffect(() => {
    const fetchFacebookFeed = async () => {
      try {
        setLoading(true);
        const response = await fetch(API_URL);

        if (!response.ok) {
          throw new Error('ไม่สามารถดึงข้อมูลจาก Facebook ได้');
        }

        const result = await response.json();
        const filteredData = result.data.filter(post => post.full_picture);
        setPosts(filteredData);
      } catch (err) {
        setError(err.message || 'เกิดข้อผิดพลาดบางอย่าง');
      } finally {
        setLoading(false);
      }
    };

    fetchFacebookFeed();
  }, []);

  // สร้าง array ของหน้าที่จะแสดง
  const getPageNumbers = () => {
    const pages = [];
    let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = startPage + maxPagesToShow - 1;

    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  };

  useEffect(() => {
    localStorage.removeItem("selectedItem");
    // Initialize Viewer.js สำหรับ container
    if (containerRef.current && !viewerInstance.current) {
      viewerInstance.current = new Viewer(containerRef.current, {
        inline: false,
        title: false,
        toolbar: {
          zoomIn: 1,
          zoomOut: 1,
          oneToOne: 1,
          reset: 1,
          prev: 1,
          play: 0,
          next: 1,
          rotateLeft: 1,
          rotateRight: 1,
          flipHorizontal: 1,
          flipVertical: 1,
        },
      });
    }

    return () => {
      // ทำลาย Instance เมื่อ Component ถูกลบ
      if (viewerInstance.current) {
        viewerInstance.current.destroy();
        viewerInstance.current = null;
      }
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      // ตรวจสอบขนาดหน้าจอ หากกว้างน้อยกว่า 768px ให้กำหนด isMobile เป็น true
      setIsMobile(window.innerWidth < 768);
    };

    // เรียกใช้งานฟังก์ชันตรวจสอบขนาดหน้าจอครั้งแรก
    handleResize();

    // เพิ่ม event listener เพื่อตรวจสอบขนาดหน้าจอเมื่อมีการเปลี่ยนแปลง
    window.addEventListener("resize", handleResize);

    // ลบ event listener เมื่อ component ถูก unmount เพื่อป้องกัน memory leak
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const MotionWrapper = isMobile ? "div" : motion.div;

  return (
    <>
      {/* About Us */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-3 gap-y-3 ">
        <div className="flex flex-col gap-y-4">
          <div className="flex flex-col gap-y-2">
            <span className="font-bold text-[#0F4D81] text-2xl">
              NORTHERN REGIONAL VETERINARY HEALTHCARE AND LEARNING CENTER
            </span>
            <span className="font-medium text-gray-800 text-xl">
              ศูนย์การเรียนรู้และส่งเสริมสุขภาพทางสัตวแพทย์ภาคเหนือ
            </span>
          </div>

          <div className="text-gray-700 lg:text-base text-sm">
            ศูนย์การเรียนรู้ และส่งเสริมสุขภาพทางสัตวแพทย์ภาคเหนือ NOVEL CMU
            เริ่มก่อสร้างเมื่อปี 2562 ณ พื้นที่ศูนย์วิจัย
            สาธิตและฝึกอบรมการเกษตรแม่เหียะ ต.แม่เหียะ อ.เมือง จ.เชียงใหม่
            ซึ่งเป็นบริเวณที่ตั้งของคณะสัตวแพทยศาสตร์ มหาวิทยาลัยเชียงใหม่ ณ
            ปัจจุบัน เป็นอาคารสูง 4 ชั้น พื้นที่สอยประมาณ 17,968 ตาราง
            เปิดให้การรักษาโรคทั่วไปและโรคเฉพาะทางที่มีความซับซ้อนอย่างครบวงจร
            ต่อมาได้กราบบังคมทูล
            <b>
              {" "}
              พระกนิษฐาธิราชเจ้า กรมสมเด็จพระเทพรัตนราชสุดาฯ สยามบรมราชกุมารี{" "}
            </b>
            ขอพระราชทานชื่ออาคาร "ศูนย์สุขภาพสัตว์ดอยคำ" พระองค์ท่าน
            ทรงกรุณาพระราชทานชื่ออาคารดังกล่าวว่า "สัตวเวชบำรุง" หมายถึง
            อาคารที่แหล่งบำรุงรักษาทางการแพทย์ให้แก่สัตว์
            และพระราชทานพระราชานุญาตให้เชิญอักษรพระนามาภิไธย "ส.ธ."
            ประดับที่ป้ายชื่อพระราชทาน อย่างเป็นทางการเมื่อวันที่ 29 กันยายน
            2567
          </div>
        </div>
        <div className="w-full h-full overflow-hidden flex justify-center">
          <img
            src="/images/banner/banner1.jpg"
            alt=""
            className="object-cover rounded-md"
          />
        </div>
      </div>

      {/* Executive Message - สารจากผู้บริหาร - ออกแบบใหม่ทันสมัย */}
      <div className="mt-12 mb-8">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#0F4D81] via-[#1a6bb0] to-[#9E76B3] shadow-2xl">
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-20 -mt-20"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full -ml-16 -mb-16"></div>
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-white/5 rounded-full"></div>

          <div className="relative px-6 py-8 md:px-10 md:py-10">
            {/* Header */}
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
                <i className="fa-solid fa-pen-fancy text-white text-2xl"></i>
              </div>
              <div>
                <h2 className="text-white text-2xl md:text-3xl font-bold tracking-wide">
                  สารจากผู้บริหาร
                </h2>

              </div>
              <div className="ml-auto hidden md:block">
                <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center">
                  <i className="fa-solid fa-quote-right text-white/40 text-3xl"></i>
                </div>
              </div>
            </div>

            {/* Content */}
            <div className="space-y-4 text-white/95 leading-relaxed">
              <p className="text-base md:text-lg">
                ศูนย์การเรียนรู้และส่งเสริมสุขภาพทางสัตวแพทย์ภาคเหนือ (Northern Regional Veterinary Healthcare and Learning Center: NOVEL) ก่อตั้งขึ้นภายใต้คณะสัตวแพทยศาสตร์ มหาวิทยาลัยเชียงใหม่ ด้วยปณิธานที่จะเป็น <span className="font-semibold text-yellow-200">"โรงพยาบาลสัตว์ส่งต่อและศูนย์การเรียนรู้ทางสัตวแพทย์ระดับสากล"</span> โดยมุ่งพัฒนาระบบบริการสุขภาพสัตว์ที่มีคุณภาพ เชื่อมโยงการรักษาพยาบาล การเรียนการสอน การวิจัย และการบริการวิชาการเข้าด้วยกัน เพื่อสร้างประโยชน์สูงสุดต่อสัตว์ป่วย เจ้าของสัตว์ และวิชาชีพสัตวแพทย์ของประเทศ
              </p>

              <p className="text-base md:text-lg">
                ตลอดระยะเวลาที่ผ่านมา NOVEL ได้ยึดมั่นในพันธกิจสำคัญ 5 ประการ ได้แก่ การให้บริการทางสัตวแพทย์ด้วยมาตรฐานสากลและเทคโนโลยีที่ทันสมัย การพัฒนาการเรียนรู้และการฝึกปฏิบัติทางคลินิกอย่างมีคุณภาพ การสนับสนุนงานวิจัยและนวัตกรรมเพื่อยกระดับการรักษา การถ่ายทอดองค์ความรู้และสร้างเครือข่ายวิชาชีพทั้งในและต่างประเทศ ตลอดจนการบริหารองค์กรภายใต้หลักคุณภาพและธรรมาภิบาล ซึ่งเป็นรากฐานสำคัญของการพัฒนาองค์กรอย่างยั่งยืน
              </p>

              {/* Highlight Box */}
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-6 border border-white/20 my-4">
                <div className="flex items-start gap-3">
                  <div className="text-yellow-300 text-xl mt-1">
                    <i className="fa-solid fa-bullseye"></i>
                  </div>
                  <div>
                    <h4 className="text-white font-semibold text-lg">หัวใจสำคัญของการก่อตั้ง NOVEL</h4>
                    <p className="text-white/90 text-base">
                      คือการเป็น Veterinary Referral Hospital ที่สามารถเชื่อมโยงการดูแลรักษาสัตว์ป่วยระหว่างคลินิกสัตวแพทย์ โรงพยาบาลสัตว์ และสถาบันการศึกษาทั่วภาคเหนือ เพื่อให้สัตว์ป่วยได้รับการรักษาที่เหมาะสมตามศักยภาพของแต่ละหน่วยบริการ พร้อมทั้งสนับสนุนการแลกเปลี่ยนองค์ความรู้และประสบการณ์ทางวิชาชีพระหว่างสัตวแพทย์ผู้ประกอบวิชาชีพ
                    </p>
                  </div>
                </div>
              </div>

              <p className="text-base md:text-lg">
                ในปี พ.ศ. 2569 ศูนย์ได้กำหนด <span className="font-semibold text-yellow-200">"Quality Beyond Treatment: Excellence in Referral and Client Experience"</span> เป็นแนวทางสำคัญในการพัฒนาองค์กร โดยมุ่งยกระดับทั้งคุณภาพการรักษาและประสบการณ์ของผู้รับบริการ (Client Experience) ตั้งแต่ระบบการนัดหมาย การรับส่งต่อผู้ป่วย การสื่อสารข้อมูลทางการแพทย์ การประสานงานกับสัตวแพทย์ผู้ส่งต่อ การดูแลเจ้าของสัตว์ระหว่างการรักษา ตลอดจนการติดตามผลหลังการรักษา เพื่อให้ทุกกระบวนการมีมาตรฐาน โปร่งใส รวดเร็ว และสร้างความเชื่อมั่นแก่ผู้รับบริการและสัตวแพทย์เครือข่าย
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 my-4">
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20">
                  <div className="flex items-center gap-2 mb-2">
                    <div className="text-emerald-300">
                      <i className="fa-solid fa-certificate"></i>
                    </div>
                    <h4 className="text-white font-semibold">การบริหารคุณภาพระดับสากล</h4>
                  </div>
                  <p className="text-white/90 text-sm">
                    เพื่อสนับสนุนการพัฒนาองค์กรอย่างเป็นระบบ NOVEL ได้นำหลักการบริหารคุณภาพระดับสากลมาประยุกต์ใช้ในการดำเนินงาน โดยมุ่งสู่การพัฒนาระบบบริหารคุณภาพตาม ISO 9001:2015 เพื่อยกระดับประสิทธิภาพของกระบวนการทำงานและการปรับปรุงคุณภาพอย่างต่อเนื่อง ควบคู่กับการนำมาตรฐาน Thai Animal Hospital Accreditation (TASHA) มาใช้เป็นกรอบในการพัฒนาคุณภาพโรงพยาบาลสัตว์ ทั้งด้านความปลอดภัยของผู้ป่วย มาตรฐานการรักษา การบริหารความเสี่ยง การพัฒนาบุคลากร และการสร้างวัฒนธรรมคุณภาพภายในองค์กร ทั้งนี้เพื่อให้ NOVEL ก้าวสู่การเป็นโรงพยาบาลสัตว์มหาวิทยาลัยที่ได้รับการยอมรับในระดับประเทศและระดับนานาชาติ
                  </p>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20">
                  <div className="flex items-center gap-2 mb-2">
                    <div className="text-purple-300">
                      <i className="fa-solid fa-handshake"></i>
                    </div>
                    <h4 className="text-white font-semibold">โครงการ CVR-APP</h4>
                  </div>
                  <p className="text-white/90 text-sm">
                    ในขณะเดียวกัน คณะสัตวแพทยศาสตร์ มหาวิทยาลัยเชียงใหม่ ได้ริเริ่ม โครงการ CMU Veterinary Referral & Academic Partnership Program (CVR-APP) โดยมี NOVEL เป็นหน่วยงานหลักในการบริหารจัดการโครงการ เพื่อสร้างเครือข่ายความร่วมมือด้านการส่งต่อผู้ป่วย การพัฒนาวิชาชีพ การวิจัย และการบริการวิชาการกับคลินิกสัตวแพทย์ โรงพยาบาลสัตว์ และองค์กรวิชาชีพ เราเชื่อมั่นว่าการยกระดับคุณภาพการรักษาสัตว์ในอนาคตจะเกิดขึ้นได้จาก เครือข่ายความร่วมมือที่เข้มแข็ง การแลกเปลี่ยนองค์ความรู้ และการพัฒนามาตรฐานร่วมกัน มากกว่าการดำเนินงานขององค์กรใดองค์กรหนึ่งเพียงลำพัง
                  </p>
                </div>
              </div>

              {/* Closing statement */}
              <div className="border-t border-white/20 pt-4 ">
                <div className="flex items-center gap-4 mt-3">

                  <div>

                    <p className="text-white/60 text-sm">ในนามของผู้บริหารศูนย์การเรียนรู้และส่งเสริมสุขภาพทางสัตวแพทย์ภาคเหนือ ผมขอขอบคุณสัตวแพทย์ เจ้าของสถานพยาบาลสัตว์ หน่วยงานภาครัฐ ภาคเอกชน และพันธมิตรทุกภาคส่วน ที่ให้ความไว้วางใจและร่วมเดินเคียงข้างกับเรามาโดยตลอด เราจะยังคงยึดมั่นในปณิธานของการเป็น โรงพยาบาลสัตว์ส่งต่อและศูนย์การเรียนรู้ทางสัตวแพทย์ระดับสากล พร้อมพัฒนาองค์กรอย่างไม่หยุดยั้ง เพื่อยกระดับคุณภาพการรักษา พัฒนาวิชาชีพ และสร้างเครือข่ายบริการสัตวแพทย์ที่เข้มแข็ง เพื่อประโยชน์สูงสุดของสัตว์ เจ้าของสัตว์ และสังคมไทยอย่างยั่งยืน</p>
                  </div>
                </div>
                <p className="text-base md:text-lg italic text-white/90 mt-4">
                  "Together We Advance Veterinary Excellence through Partnership, Learning, and Quality."
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* News */}
      <div className="flex flex-col gap-y-2 text-2xl font-bold">
        <div className="flex justify-between items-center gap-x-2 text-[#0F4D81]">
          <div className="flex gap-x-2">
            <i className="fa fa-paw"></i>
            <span>ข่าวประชาสัมพันธ์</span>
          </div>
        </div>
      </div>
      {loading ? (
        <div className="flex justify-center items-center py-10">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-[#0F4D81]"></div>
        </div>
      ) : error ? (
        <div className="text-red-500 text-center py-6">{error}</div>
      ) : posts.length === 0 ? (
        <div className="text-gray-500 text-center py-6">ไม่มีข้อมูล</div>
      ) : (
        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-4">
          {currentItems.map((post) => (

            <div
              key={post.id}
              className="flex flex-col border border-gray-100 rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-200"
            >
              {post.full_picture && (
                <img
                  src={post.full_picture}
                  alt="post"
                  className="w-full h-72 object-cover"
                />
              )}
              <div className="flex flex-col gap-y-2 p-3 flex-1">
                <span className="text-xs text-gray-400">
                  {new Date(post.created_time).toLocaleDateString("th-TH", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </span>
                {post.message && (
                  <p className="text-gray-700 text-sm line-clamp-3">
                    {post.message}
                  </p>
                )}
                {post.actions?.[0]?.link && (
                  <a
                    href={post.actions[0].link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-auto pt-2 text-[#0F4D81] text-sm font-medium hover:underline"
                  >
                    อ่านเพิ่มเติม{" "}
                    <i className="fa fa-external-link-alt text-xs ml-1"></i>
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Pagination Controls */}
      {!loading && !error && posts.length > itemsPerPage && (
        <div className="flex justify-start flex-wrap gap-1">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
            className="px-3 py-1 rounded bg-gray-200 disabled:opacity-50 text-[#0F4D81]"
          >
            <i className="fa fa-arrow-left"></i>
          </button>

          {currentPage > maxPagesToShow / 2 + 1 && (
            <>
              <button
                onClick={() => paginate(1)}
                className="px-3 py-1 rounded bg-gray-200 text-[#0F4D81]"
              >
                1
              </button>
              <span className="px-3 py-1">...</span>
            </>
          )}

          {getPageNumbers().map((page) => (
            <button
              key={page}
              onClick={() => paginate(page)}
              className={`px-3 py-1 rounded ${currentPage === page
                ? "bg-[#0F4D81] text-white"
                : "bg-gray-200 text-[#0F4D81]"
                }`}
            >
              {page}
            </button>
          ))}

          {currentPage < totalPages - maxPagesToShow / 2 && (
            <>
              <span className="px-3 py-1">...</span>
              <button
                onClick={() => paginate(totalPages)}
                className="px-3 py-1 rounded bg-gray-200 text-[#0F4D81]"
              >
                {totalPages}
              </button>
            </>
          )}

          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="px-3 py-1 rounded bg-gray-200 disabled:opacity-50 text-[#0F4D81]"
          >
            <i className="fa fa-arrow-right"></i>
          </button>
        </div>
      )}

      {/* Content */}
      <div className="flex flex-col gap-y-2 text-2xl font-bold">
        <div className="flex justify-between">
          <div className="flex gap-x-2 text-[#0F4D81]">
            <i className="fa fa-paw"></i>
            <span>ความรู้ต่างๆเกี่ยวกับสัตว์เลี้ยง</span>
          </div>
        </div>
      </div>

      {/* ใช้ ref ที่ Container แทนแต่ละรูปภาพ */}
      <div
        ref={containerRef}
        className="grid md:grid-cols-4 grid-cols-2 justify-center items-center gap-3"
      >
        {bannerHealth.map((item, index) => (
          <div key={item.id} className="relative group w-full h-96">
            <img
              src={item.img ? item.img : "/images/info/notImg.png"}
              alt={`ความรู้เกี่ยวกับสัตว์เลี้ยง ${index + 1}`}
              className="object-cover rounded-md shadow shadow-blue-300 w-full h-full"
            />
            <div className="absolute bottom-0 left-0 right-0 flex justify-center items-center bg-black/50 h-0 group-hover:h-full transition-all duration-300 ease-in-out">
              <div
                onClick={() => {
                  // เรียกแสดงรูปภาพตาม Index
                  if (viewerInstance.current) {
                    viewerInstance.current.view(index);
                  }
                }}
                className="bg-gray-400/50  text-gray-100 px-2 py-1 rounded-md shadow-lg text-[14px] opacity-0 group-hover:opacity-100 transition-opacity duration-300 cursor-pointer"
              >
                View image
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Floor */}
      <MotionWrapper
        className="flex flex-col gap-y-4 px-4 sm:px-6 md:px-8"
        {...(!isMobile && {
          // initial: { opacity: 0, y: 50 },
          initial: false,
          // whileInView: { opacity: 1, y: 0 },
          viewport: { once: false, amount: 0.5 },
          // transition: { duration: 0.8, ease: "easeOut" },
        })}
      >
        <div className="grid grid-cols-1 md:grid-cols-1 space-y-4">
          <div className="flex flex-col w-full gap-3 border p-3 border-gray-100 rounded-lg shadow-md">
            <MotionWrapper
              className="flex justify-start items-start space-x-3 text-3xl sm:text-4xl md:text-5xl font-bold text-[#0F4D81] border-b-2 py-2"
              {...(!isMobile && {
                // initial: { opacity: 0, x: -50 },
                initial: false,
                // whileInView: { opacity: 1, x: 0 },
                // transition: { duration: 0.8, ease: "easeOut" },
              })}
            >
              <span>
                <i className="fa-solid fa-layer-group text-[#9E76B3]"></i>
              </span>
              <span>Floor (ชั้น)</span>
            </MotionWrapper>
            {dataFloor.length > 0 &&
              dataFloor.map((item, index) => (
                <MotionWrapper
                  key={index}
                  className="flex flex-col md:flex-row relative border-b-2 px-2 py-5 gap-x-3"
                  {...(!isMobile && {
                    // initial: { opacity: 0, y: 50 },
                    initial: false,
                    // whileInView: { opacity: 1, y: 0 },
                    // transition: {
                    //   duration: 0.8,
                    //   ease: "easeOut",
                    //   delay: index * 0.2,
                    // },
                  })}
                >
                  <div className="hidden md:flex text-5xl sm:text-6xl md:text-7xl font-medium text-[#0F4D81] border-r-2 pr-2">
                    {item.floor}
                  </div>
                  <div className="absolute inset-0 flex items-center justify-center text-[80px] sm:text-[120px] md:text-[150px] font-bold text-[#0F4D81] opacity-10">
                    {item.floor}
                  </div>
                  <div className="w-full h-full">
                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
                      {item?.rooms.length > 0 &&
                        item?.rooms.map((room, index) => (
                          <MotionWrapper
                            key={index}
                            className="flex flex-col text-center"
                            {...(!isMobile && {
                              // initial: { opacity: 0, scale: 0.8 },
                              initial: false,
                              // whileInView: { opacity: 1, scale: 1 },
                              // transition: {
                              //   duration: 0.5,
                              //   ease: "easeOut",
                              //   delay: index * 0.1,
                              // },
                            })}
                          >
                            <div className="text-[#9E76B3] text-base sm:text-lg">
                              {room.roomname_th}
                            </div>
                            <div className="text-[12px] sm:text-[14px] text-[#0F4D81]">
                              {room.roomname_en}
                            </div>
                          </MotionWrapper>
                        ))}
                    </div>
                  </div>
                </MotionWrapper>
              ))}
          </div>
        </div>
      </MotionWrapper>
    </>
  );
}